import { Box, Typography } from '@mui/material';
import { PlatformType } from '@okletsplay/core';
import { ModalName } from 'app/enums';
import { modalsReducers } from 'app/store/modal/slice';
import React, { FC, ReactElement, useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { TextInput } from 'shared/components/Form/TextInput';

interface BracketTournamentCodeModalBodyProps {
  code: string;
  isFinished: boolean;
  platformType?: PlatformType;
}

const TIMER_DURATION = 15 * 1000;
let timer: NodeJS.Timeout | string | number | undefined;

export const BracketTournamentCodeModalBody: FC<BracketTournamentCodeModalBodyProps> = ({
  code,
  isFinished,
  platformType,
}) => {
  const dispatch = useDispatch();

  const onCopyHandler = useCallback(() => {
    clearTimeout(timer);
    timer = setTimeout(
      () => dispatch(modalsReducers.closeModal(ModalName.TournamentCode)),
      TIMER_DURATION
    );
  }, [dispatch]);

  const content = useMemo<Partial<Record<PlatformType, ReactElement>>>(() => {
    const joinLinkContent = (
      <>
        <Typography mb={2}>
          Click the &quot;Play Now&quot; button to open the game and join the lobby.
        </Typography>
        <Box width="100%">
          <Typography variant="subtitle1" fontWeight="bold" mb={1}>
            Challenge URL
          </Typography>
          <TextInput withCopy readOnly value={code} onCopyHandler={onCopyHandler} />
        </Box>
      </>
    );

    return {
      [PlatformType.LeagueOfLegends]: (
        <>
          <Typography mb={2}>
            Launch the League of Legends client and select &quot;Play&quot;. Then click on the
            Tournament button (Trophy in the top-right corner) and activate the copied code.
          </Typography>
          <Box width="100%">
            <Typography variant="subtitle1" fontWeight="bold" mb={1}>
              Tournament Code
            </Typography>
            <TextInput withCopy readOnly value={code} onCopyHandler={onCopyHandler} />
          </Box>
        </>
      ),
      [PlatformType.Papergames]: joinLinkContent,
      [PlatformType.Lichess]: joinLinkContent,
      [PlatformType.EvIo]: joinLinkContent,
    };
  }, [code, onCopyHandler]);

  if (isFinished) {
    return <Typography variant="h5">Finished Match or Expired Code</Typography>;
  }

  return content[platformType as PlatformType] ?? null;
};
